import styled from 'styled-components';

const SearchContainer = styled.div`
  padding: 32px 5%;
  margin: auto;
  background-color: #fafafa;
  min-height: calc(100vh - 80px);
`;

export default SearchContainer;
